import React, { useEffect, useState } from "react";
import { Modal, Form } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import {
  emailNotification,
  emailUnsubscribe
} from "../../../redux/actions/UserAction";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "react-simple-snackbar";
import sms from "../../../assets/sms.png";
import email from "../../../assets/email.png"

function Notifications(props) {
  const history = useHistory();
  const userRes = JSON.parse(localStorage.getItem("USERRES"));
  const dispatch = useDispatch();
  const [userEmail, setUserEmail] = useState("");
  const [emailExist, setEmailExist] = useState(null);
  const [emailVerified, setEmailVerified] = useState(false);
  const [emailTick, setEmailTick] = useState("");
  const [takeEmail, setTakeEmail] = useState("");
  const [reEnter, setReEnter] = useState(false);
  const [openSnackbar, closeSnackbar] = useSnackbar();
  const [verificationMailSent, setVerificationMailSent]=useState(null);
  const [loader, setLoader] = useState(null);

  const handleClick = () => {
    if (emailTick == false) {
      setEmailTick(true);
      setTakeEmail(true);
      if (emailVerified == true) {
        const savedEmail = userRes.data.learner.email;
        const email = { email: savedEmail };
        const onSuccess = (data) => {
          userRes.data.learner.isSubscribedToEmail = true;
          localStorage.setItem("USERRES", JSON.stringify(userRes));
          console.log("Email success");
          console.log(data)

          openSnackbar("Email notifications enabled")
          // history.push("/my_account");
          // window.location.reload();

        }
        const onError = (data) => {
          window.location.reload();
          openSnackbar("Some error occured")
          console.log(data)
          console.log("Email error")
        }
        dispatch(emailNotification(email, onSuccess, onError))
      }
    }
    else if (emailTick == true) {
      setEmailTick(false);
      const onSuccess = () => {
        userRes.data.learner.isSubscribedToEmail = false;
        localStorage.setItem("USERRES", JSON.stringify(userRes));
        console.log("unsubscribe success");
        openSnackbar("Email notifications disabled")
        // window.location.reload();
      }
      const onError = (data) => {
        // console.log(data)
        console.log("unsubscribe error")
        openSnackbar("Some error occured")
      }
      dispatch(emailUnsubscribe(onSuccess, onError))
    }
  }
  // console.log(userRes.data.learner)

  const submitEmail = (e) => {
    setLoader(true);
    e.preventDefault();
    const email = { email: userEmail };
    const onSuccess = () => {
      setLoader(false)
      userRes.data.learner.isSubscribedToEmail = true;
      localStorage.setItem("USERRES", JSON.stringify(userRes));
      console.log("Email success");
      setVerificationMailSent("Email verification link sent successfully. Check your email to verify.")
      openSnackbar("Verification mail sent")     
      // history.push("/my_account");
      // window.location.reload();

    }
    const onError = (data) => {
      window.location.reload();
      setLoader(false)
      openSnackbar("Some error occured")
      // console.log(data)
      console.log("Email error")
    }
    dispatch(emailNotification(email, onSuccess, onError))
  }

  useEffect(() => {
    if (userRes.data.learner.email) {
      setEmailExist(true);
    }
    if (userRes.data.learner.isSubscribedToEmail) {

      setEmailTick(true);
    }
    else if (userRes.data.learner.isSubscribedToEmail == false) {

      setEmailTick(false);
    }

    setEmailVerified(userRes.data.learner.isEmailVerified);



  }, []);

  // console.log(`email exist ${emailExist}`);
  // console.log(`email verified ${emailVerified}`);
  // console.log(`email tick ${emailTick}`);
  // console.log(`email subscribed ${userRes.data.learner.isSubscribedToEmail}`);
  return (
    <div className="card">
     
          <h4>Notifications</h4>
          <p style={{ color: "grey" }}>Session and payment reminders</p>
          {/* <div className="d-flex justify-content-between">
            <div className>
              <img src={sms} alt="sms" />
              <span className="ml-2">SMS</span>
            </div>
            <div className="d-flex " >
              <div class="form-check" >
                <input class="form-check-input" type="checkbox" value="" onClick={() => handleClick()} style={{ width: "15px", height: "15px" }} id="flexCheckChecked" />
              </div>
            </div>

          </div> */}
          <div className="d-flex justify-content-between mt-3">
            <div className>
              <img src={email} alt="sms" />
              <span className="ml-2">Email</span>
            </div>
            <div className="d-flex " >
              <div class="form-check" >
                <input class="form-check-input" type="checkbox" checked={emailTick} value="" onClick={() => handleClick()} style={{ width: "15px", height: "15px"}} id="flexCheckChecked" />
              </div>
            </div>
          </div>
          <div>
            {(emailVerified == false && (takeEmail == true || reEnter == true)) ?
              <Form onSubmit={(e) => submitEmail(e)}>
                <div className="d-flex mt-2 ml-3">
                  <Form.Group controlId="formBasicPassword">
                    <Form.Control
                      style={{ borderTop: "none", borderLeft: "none", borderRight: "none",fontSize:"14px" }}
                      type="email"
                      placeholder="Enter your email"
                      value={userEmail}
                      onChange={(e) => setUserEmail(e.target.value)}
                      required
                    />
                  </Form.Group>

                  <button
                    style={{ width: "120px", height: "25px", background: "none", color: "#4DC591", border: "none", boxShadow:"none",marginTop:"10px" }}
                    type="submit" >{loader?"Processing": verificationMailSent?"Done" :"Submit"}</button>
                </div>
                <span style={{fontSize:"14px"}}>{verificationMailSent? verificationMailSent:""}</span>
              </Form> : ""}
          </div>
          {(emailExist == true && emailVerified == false) ?
            <span style={{fontSize:"14px", color:"red"}}>Your email is not verified. <br/>Check your mail for verification or <span style={{ cursor: "pointer", color: "#4DC591" }} onClick={() => setReEnter(true)}>click here</span> to enter a new email.</span> : ""}
      
    </div>
  );
}

export default Notifications;
